import { configureStore } from '@reduxjs/toolkit';
import cartReducer from './slices/cartSlice';
import listingFilterReducer from './slices/listingFilterSlice';

export default configureStore({
    reducer: {
        cart: cartReducer,
        listingFilters: listingFilterReducer,
    },
  });